import * as React from "react";
import { withRouter } from "react-router-dom";
import { RouterState } from "react-router-redux";
import { Helmet } from "react-helmet";

import * as constants from "./constants";

export interface HeadContainerProps extends RouterState {
  pageMetaDict: constants.PageMetaDict;
}

class HeadContainer extends React.Component<HeadContainerProps> {
  public static defaultProps: Partial<HeadContainerProps> = {
    pageMetaDict: constants.PAGE_META_DICT,
  };

  private renderOGTags = () => {
    const { location, pageMetaDict } = this.props;

    if (!location) {
      return [];
    }

    return (pageMetaDict[location.pathname] || pageMetaDict.default).og
      .map((tag, i) => (
        <meta key={i} property={`og:${tag.property}`} content={tag.content} />
      ));
  };

  public render() {
    return <Helmet>{this.renderOGTags()}</Helmet>;
  }
}

export default withRouter(HeadContainer);



// WEBPACK FOOTER //
// ./src/head/HeadContainer.tsx